function UserSquareIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0001 15.1659H6.00006C5.12006 15.1659 4.38672 15.0792 3.76672 14.8925C3.54006 14.8259 3.39339 14.6059 3.40672 14.3725C3.57339 12.3792 5.59339 10.8125 8.00006 10.8125C10.4067 10.8125 12.4201 12.3725 12.5934 14.3725C12.6134 14.6125 12.4667 14.8259 12.2334 14.8925C11.6134 15.0792 10.8801 15.1659 10.0001 15.1659ZM4.48006 14.0392C4.92006 14.1259 5.42006 14.1659 6.00006 14.1659H10.0001C10.5801 14.1659 11.0801 14.1259 11.5201 14.0392C11.1667 12.7592 9.70672 11.8125 8.00006 11.8125C6.29339 11.8125 4.83339 12.7592 4.48006 14.0392Z"
        fill="#5570F1"
      />
      <path
        d="M10 1.33203H6.00004C2.66671 1.33203 1.33337 2.66536 1.33337 5.9987V9.9987C1.33337 12.5187 2.09337 13.8987 3.90671 14.412C4.05337 12.6787 5.83337 11.312 8.00004 11.312C10.1667 11.312 11.9467 12.6787 12.0934 14.412C13.9067 13.8987 14.6667 12.5187 14.6667 9.9987V5.9987C14.6667 2.66536 13.3334 1.33203 10 1.33203ZM8.00004 9.44535C6.68004 9.44535 5.61337 8.37204 5.61337 7.05204C5.61337 5.73204 6.68004 4.66536 8.00004 4.66536C9.32004 4.66536 10.3867 5.73204 10.3867 7.05204C10.3867 8.37204 9.32004 9.44535 8.00004 9.44535Z"
        stroke="#5570F1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99995 9.94796C6.40662 9.94796 5.11328 8.64798 5.11328 7.05465C5.11328 5.46131 6.40662 4.16797 7.99995 4.16797C9.59328 4.16797 10.8866 5.46131 10.8866 7.05465C10.8866 8.64798 9.59328 9.94796 7.99995 9.94796ZM7.99995 5.16797C6.95995 5.16797 6.11328 6.01465 6.11328 7.05465C6.11328 8.10131 6.95995 8.94796 7.99995 8.94796C9.03995 8.94796 9.88662 8.10131 9.88662 7.05465C9.88662 6.01465 9.03995 5.16797 7.99995 5.16797Z"
        fill="#5570F1"
      />
    </svg>
  );
}

export default UserSquareIcon;
